module.exports = __webpack_public_path__ + "images/backgroundImg4.jpg";